import { render } from "./TrainerSessionManagement.vue?vue&type=template&id=b4b35e4c&scoped=true"
import script from "./TrainerSessionManagement.vue?vue&type=script&lang=js"
export * from "./TrainerSessionManagement.vue?vue&type=script&lang=js"

import "./TrainerSessionManagement.vue?vue&type=style&index=0&id=b4b35e4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b35e4c"]])

export default __exports__